


export const getDeepProp = (obj: Object, prop: string) => {
  const props = prop.split('.');

  let p: string;
  let found: unknown = obj;
  // date.dateformat
  while (props.length) {
    p = props.shift();
    found = found[p];
    if (props.length) {
      if (typeof found !== 'object' || found[p] === null) {
        return void 0;
      }
    }
    else {
      return found;
    }
  }
};


export const setDeepProp = (obj: Object, deepProp: string, value: unknown) => {
  const props = deepProp.split('.');
  let p;
  let found = obj;
  // date.dateformat
  while (props.length) {
    p = props.shift();
    if (props.length) {
      found = found[p];
    }
    else if (found && typeof found === "object") {
      found[p] = value;
    }
  }
  return obj;
};



export const callDeepProp = (
  {obj, deepProp, args, defValue, defArgs = []}: {obj: Object, deepProp: string, args: [], defValue: unknown, defArgs: []}
) => {
  let val;
  const _args = Array.isArray(args) ? args : defArgs;

  if (typeof obj === "object" && obj) {
    val = getDeepProp(obj, deepProp);

    val = typeof val === "function"
      ? val.apply(obj, _args)
      : val
    ;
  }
  const r = typeof val === "undefined"
    ? typeof defValue === "function" ? defValue.apply(obj, _args) : defValue
    : typeof val === "function" ? val.apply(obj, _args) : val
  ;
  // console.warn(deepProp, r)
  return r;
};
